import React from 'react';
import { config } from '../../../utils/config.js';
import { FileUpload as CmpFileUpload } from "../../../components/FileUpload/index.js";
import { Label as CmpLabel } from "../../../components/Label/index.js";
import { Textbox as CmpTextbox } from "../../../components/Textbox/index.js";
import GenericModal from '../../../components/Modals/genericModal.js';

export default function UploadLogicFileDialog({openFileUpload, setOpenFileUpload, onFileUpload, isUploading, fileToUpload, setFileToUpload, onFileSelected, fileComment, onFileComment}) {
  return (
    <GenericModal open={openFileUpload} setOpen={setOpenFileUpload}
    onConfirm={() => onFileUpload({fileToUpload}, fileComment)}
    onCancel={() => {
      setOpenFileUpload(false);
      setFileToUpload(null);
    }}
    showCancelButton={true}
    confirmButtonDisabled={!fileToUpload || !fileComment || isUploading}
    confirmButtonText={'Upload'}
    title="Upload logic file">
    <div className="mt-4">
      <CmpFileUpload
        name="templateFile"
        label={"Logic file"}
        fileExtension=".mfl"
        onChange={onFileSelected}
        maxFileSizeMb={config.maxLogicFileSizeMb}
      />
      {fileToUpload &&
        <CmpLabel text={`Selected file: ${fileToUpload.name}`} />
      }
      <CmpTextbox additionalClass="mt-4"
        name="type"
        value={fileComment}
        label="Comment"
        onChange={onFileComment}
       />
    </div>
  </GenericModal>  );
}